var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPermitted('request'))?_c('b-nav-item',{attrs:{"right":"","title":_vm.count},on:{"click":_vm.navToRequest}},[_c('feather-icon',{staticClass:"text-body",attrs:{"icon":"MessageSquareIcon","size":"21"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }